import React, {Component, ReactElement} from 'react'
import PreformattedDiv from '../../../styledComponents/PreformattedDiv'
import {Messages} from '../../../Messages'
import {Nullable} from '../../../app/TypeHelpers'
import {WideMainContainer} from '../../../styledComponents/ContentsArea'
import styled from 'styled-components'
import NotInterestedIcon from '@mui/icons-material/NotInterested'
import UpdateIcon from '@mui/icons-material/Update'
import {Colors} from '../../../styledComponents/Constants'
import {Box} from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import {createGuestPage, GuestPagePropsSet} from '../../../components/shared/hoc/createGuestPage'
import {ErrorResponseBody} from '../../../network/response/ErrorResponseBody'
import {Location} from 'react-router-dom'

export interface NatGuestSystemErrorLocationState {
    icon: ErrorIcon
    title: string
    message: string
    errorResponseBody: ErrorResponseBody
}

interface Props {
    location: Location<NatGuestSystemErrorLocationState>
}

interface State {
    icon: ErrorIcon
    title: string
    message: string
}

type ErrorIcon = 'DefaultIcon' | 'WaitIcon'

export const ERROR_ICON_MAP = new Map<string, ErrorIcon>([
    [Messages.EOSTG0001.message, 'DefaultIcon'],
    [Messages.EOSTG0004.message, 'DefaultIcon'],
    [Messages.EOSTG0006.message, 'WaitIcon'],
    [Messages.EOSTG0008.message, 'DefaultIcon']
])

class NatGuestSystemErrorPage extends Component<Props & GuestPagePropsSet, State> {
    constructor(props: Readonly<Props & GuestPagePropsSet>) {
        super(props)

        // 遷移もとから指定されていれば設定、そうでなければデフォルト値設定
        const icon = this.props.location.state?.icon ?? 'DefaultIcon'
        const title = this.props.location.state?.title ?? 'アクセスしようとしたページは表示できませんでした。'
        const message = this.props.location.state?.message ?? Messages.ESYCC0015.toString()

        this.state = {
            icon: icon,
            title: title,
            message: message,
        }
    }

    render(): Nullable<ReactElement> {
        return <>
            <ContentArea>
                <ErrorTitleArea>
                    {this.state.icon === 'DefaultIcon' &&
                        <StyledNotInterestedIcon/>
                    }
                    {this.state.icon === 'WaitIcon' &&
                        <StyledUpdateIcon/>
                    }
                    <ErrorTitle>
                        {this.state.title}
                    </ErrorTitle>
                </ErrorTitleArea>
                <Box height={'32px'}/>
                <WhiteArea>
                    <PreformattedDiv>{this.state.message}</PreformattedDiv>
                </WhiteArea>
            </ContentArea>
        </>
    }
}

export default createGuestPage(NatGuestSystemErrorPage)

const ContentArea = styled.div`
  margin: auto;
  padding: 15px 0;
  max-width: 738px;
`

const ErrorTitleArea = styled.div`
  display: flex;
  align-items: center;
`

const StyledNotInterestedIcon = withStyles({
    root: {
        fontSize: '48px',
        color: '#b0b0b0',
    },
})(NotInterestedIcon)

const StyledUpdateIcon = withStyles({
    root: {
        fontSize: '48px',
        color: '#b0b0b0',
    },
})(UpdateIcon)

const ErrorTitle = styled.div`
  margin-left: 8px;
  font-size: 20px;
  font-weight: bold;
  color: ${Colors.AccentDark};
`

const WhiteArea = styled(WideMainContainer)`
  padding: 15px;
`
